import { useMutation, useQueryClient } from "react-query";
import { ENDPOINTS } from "config/endpoints";
import { Request } from "types/request";
import { Response } from "types/response";
import client from "utils/client";
import { Share } from "types/share";
import { generatePath } from "react-router-dom";

export interface ForwardShareInputBlock {
  blockId: string;
  user: string;
}

export default function useCreateShare() {
  const queryClient = useQueryClient();

  const createShare = (forwardShareInput: ForwardShareInputBlock) => {
    const { blockId, user } = forwardShareInput;

    const request: Request = {
      url: generatePath(ENDPOINTS.shares.forwardBlock, { id: blockId }),
      config: {
        method: "POST",
        data: { user },
      },
    };
    return client(request);
  };

  const { data, mutateAsync, ...rest } = useMutation<
    Response<Share>,
    Error,
    ForwardShareInputBlock
  >(createShare, {
    onSettled: () => queryClient.invalidateQueries([ENDPOINTS.shares.all]),
  });

  return { data, mutateAsync, ...rest };
}
